<template>
  <div class="pay-user" :class="isWxk ? 'wxk-pay-user' : ''">
    <div class="user-head-cover" v-if="user.userId">
      <span class="img-border">
        <img class="img" :src="user.iconUrl" />
      </span>
    </div>
    <div class="user-name" v-if="user.userId">
      <dl class="uname">{{ user.nikeName }}</dl>
      <dl class="uid">ID: {{ user.userId }}</dl>
    </div>
    <div>
      <div class="user-teacher" v-if="isNeedAuthentic && success">
        <div v-if="!user.isVipForever" class="img-text-tip">报名成功后，微信搜索“友邻外刊阅读”小程序就能学习！</div>
      </div>
      <div class="vip-tip" v-if="user.userSno && !isWxk">
        <p>请务必“长按扫码”添加班主任，帮您激活听课权益，</p>
        <p>否则无法听课哦！</p>
      </div>
      <!-- 无限卡新样式 -->
      <template v-if="isWxk">
        <div class="wxk-text">添加班主任微信，激活课程服务</div>
        <div class="vip-tip" v-if="user.userSno">
          <p>添加后复制您的学号并发送给班主任</p>
          <p class="vip-tip-magin">
            学号: {{ user.userSno }}
            <span class="vip-tip-copy" @click="copyCode($event)">复制</span>
          </p>
        </div>
      </template>
      <!-- 微信二维码 -->
      <div class="user-teacher" v-if="!isNeedAuthentic && success">
        <div>
          <div class="img-qrcode">
            <img class="img" :src="user.adviserCode || defaultAdviserImg" />
          </div>
          <div v-if="user.adviserName" class="img-text" :style="isWxk ? 'color: #FF8500;' : ''">
            {{ user.adviserName || '' }}
          </div>
        </div>
        <!-- end -->
        <!-- 无限卡新样式 -->
        <div class="wxk-img-text" v-if="isWxk"></div>
        <!-- 代付成功 -->
        <div class="img-text" v-else-if="user.payAnother">
          <div class="">请截图发送ID{{ user.userId }}用户</div>
          <div>扫码添加上方班主任，激活课程服务</div>
        </div>

        <!-- 优惠劵购买提醒文案 -->
        <div class="img-text" v-else-if="user.goods_type === '80001'">如有疑问，可联系班主任微信</div>
        <template v-else>
          <!-- 积分商品下单 -->
          <div class="img-text" v-if="fromIntegral">如有疑问，可联系班主任微信</div>

          <!--2022年11月21日 新增 实物商品 -->
          <div
            class="desk coupon_tip"
            v-if="user.goods_type === '90001' || (user.goods_type === '50001' && user.equity_type === 'renewal_year')"
          ></div>
          <!-- 组合商品没有goodsId -->
          <div v-else-if="isNaN(goodsId)"></div>
          <div class="img-text" v-else>
            <div v-if="isNative">
              {{ isNative ? '添加班主任微信，激活课程服务' : '长按扫码添加班主任微信，激活课程服务' }}
            </div>
            <div v-else>添加班主任微信，激活课程服务</div>
          </div>
        </template>
        <div class="btn-common" v-if="!appUser.isWeixin" @click="!isNative ? getUrlScheme() : nativeGoMini()">
          立即添加
        </div>
        <!-- <div v-if="!user.isVipForever" class="img-text-tip">若已有班主任请勿重复添加</div> -->
      </div>
      <div v-else>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAdviserImg } from '@/pages/config'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import copyText from '@/utils/clipboard'
import { MessageBox } from 'mint-ui'
import goWeixin from '@/utils/goWeixin'
import { $gotoMiniProgramV2 } from '@/utils/common/native-api'

export default {
  name: 'PayUser',
  props: {
    user: Object,
    success: { type: Boolean, default: true },
    goodsId: [Number, String],
    fromIntegral: Boolean,
    isWxk: Boolean
  },
  data() {
    return {
      defaultAdviserImg,
      appUser
    }
  },
  computed: {
    ...mapGetters('goods/vip', ['isNeedAuthentic']),
    isNative() {
      return appUser.isNative
    }
  },
  methods: {
    copyCode(event) {
      const text = this.user.userSno
      // const text = '无限卡019999-1234567'
      copyText(text, event)
      MessageBox({
        title: '',
        message: '学号复制成功，请扫描二维码添加班主任老师为好友，把复制好的学号发给老师',
        confirmButtonText: '我知道了',
        confirmButtonClass: 'button-i_see'
      }).then(() => {
        this.step = 2
      })
    },
    getUrlScheme() {
      console.log(appUser, this.user, 'this.user.userId')
      let adviserCode = this.user.adviserCode || this.defaultAdviserImg
      let data = {
        goodsType: this.user.goodsType,
        goodsId: this.user.goodsId,
        adviserCode: adviserCode
      }

      goWeixin(1, data)
    },
    nativeGoMini(event) {
      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgramV2({
          miniUserName: mini.miniUserName,
          goMiniUrl:
            'pages/rights_receive/app_add_headTeacher/app_add_headTeacher?userId=' + appUser.userId + '&sceneId=3'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 用户
.visibi_class {
}
.pay-user {
  text-align: center;
  padding-bottom: 40px;
  padding-top: 40px;
  background-color: #ffffffff;
  margin: 40px 20px 20px;
  border-radius: 10px;
  .user-head-cover {
    margin-top: -40px;
    .img-border {
      padding: 6px;
      border-radius: 50%;
      background-color: #ffffffff;
      display: inline-block;
      .img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
  }
  .user-name dl {
    font-size: 14px;
    margin: 6px;
    &.uname {
      color: #000000;
      font-weight: 500;
    }
    &.uid {
      color: #666666;
      font-weight: 400;
    }
  }
  .vip-tip {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    .vip-tip-magin {
      margin-top: 14px;
      .vip-tip-copy {
        font-size: 12px;
        color: #00b25a;
        background-color: #f0f7f7;
        padding: 3px 8px 3px 8px;
        margin-left: 6px;
        border-radius: 2px;
      }
    }
  }
  // 班主任二维码
  .user-teacher {
    margin: 20px 0;
    color: #00b25a;
    .img {
      width: 150px;
      height: 150px;
      margin: 5px 0;
      border: 1px solid #dddddd;
    }
    .img-text {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    .img-text-tip {
      color: #999999;
      font-size: 14px;
    }
  }
}
.mint-msgbox {
  .mint-msgbox-btn.button-i_see {
    background-color: #ffde60;
    color: #63461e;
  }
}
.wxk-pay-user {
  margin-top: 0;
  padding-bottom: 24px;
  padding-top: 32px;
  box-shadow: 0px 8px 16px 0px rgba(51, 21, 0, 0.15);
  .vip-tip {
    margin-top: 8px;
    margin-bottom: -4px;
    .vip-tip-magin {
      border-top: 1px dashed rgba(0, 0, 0, 0.15);
      padding-top: 16px;
      display: inline-block;
    }
  }
}
.wxk-text {
  color: #00b25a;
  font-weight: bold;
  font-size: 16px;
  &::before {
    content: '';
    background: url(../../../../images/payment/wxk_text_icon.png) no-repeat;
    background-size: 100%;
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 8px;
  }
  &::after {
    content: '';
    background: url(../../../../images/payment/wxk_text_icon.png) no-repeat;
    background-size: 100%;
    display: inline-block;
    width: 12px;
    height: 12px;
    transform: rotateY(180deg);
    margin-left: 8px;
  }
}
.btn-common {
  border-radius: 20px;
  padding: 6px 12px;
  display: inline-block;
}
</style>
